import React from "react";

import { Switch, Route } from "react-router-dom";
import { PrivateRoute } from "../elements";
import { Design, Login } from "../components";

import { connect } from "react-redux";

const Routes = ({ isLoggedIn }) => {
  return (
    <>
      <Switch>
        <Route exact path="/login">
          <Login />
        </Route>
        <PrivateRoute exact path="/" isAuthenticated={isLoggedIn}>
          <Design />
        </PrivateRoute>
      </Switch>
    </>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: state.loginReducer.isLoggedIn,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
